var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"error-content"},[_c('img',{attrs:{"src":require("@/assets/404.png"),"alt":"404"}}),_c('div',{staticClass:"error-btn-wrap"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回首页")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }